import React, { useEffect } from 'react';

function CreateSuperpartnerForm({ formCreateSuperpartner, setFormCreateSuperpartner, showModalCreateSuperpartner }) {

    useEffect(() => {
        if (!showModalCreateSuperpartner) {
            setFormCreateSuperpartner({});
        }
    }, [showModalCreateSuperpartner, setFormCreateSuperpartner]);

    const handleFormChange = e => {
        const { name, value } = e.target;
        setFormCreateSuperpartner(prevState => ({ ...prevState, [name]: value }));
    };

    return (
        <div className='container'>
            <div className='row'>
                <div className='col-sm-12 col-md-6 my-2'>
                    <span className='small text-muted d-block mb-1'><b>Nome Superpartner</b></span>
                    <input name="nome" value={formCreateSuperpartner.nome || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Nome del Superpartner" />
                </div>
                <div className='col-sm-12 col-md-6 my-2'>
                    <span className='small text-muted d-block mb-1'><b>Partita IVA</b></span>
                    <input name="piva" value={formCreateSuperpartner.piva || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Partita IVA" />
                </div>
            </div>
            <div className='row'>
                <div className='col-sm-12 col-md-6 my-2'>
                    <span className='small text-muted d-block mb-1'><b>Indirizzo</b></span>
                    <input name="indirizzo" value={formCreateSuperpartner.indirizzo || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Indirizzo" />
                </div>
                <div className='col-sm-12 col-md-6 my-2'>
                    <span className='small text-muted d-block mb-1'><b>CAP</b></span>
                    <input name="cap" value={formCreateSuperpartner.cap || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="CAP" />
                </div>
            </div>
            <div className='row'>
                <div className='col-sm-12 col-md-6 my-2'>
                    <span className='small text-muted d-block mb-1'><b>Città</b></span>
                    <input name="citta" value={formCreateSuperpartner.citta || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Città" />
                </div>
                <div className='col-sm-12 col-md-6 my-2'>
                    <span className='small text-muted d-block mb-1'><b>Provincia</b></span>
                    <input name="provincia" value={formCreateSuperpartner.provincia || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Provincia" />
                </div>
            </div>
            <div className='row'>
                <div className='col-sm-12 col-md-6 my-2'>
                    <span className='small text-muted d-block mb-1'><b>Referente</b></span>
                    <input name="referente" value={formCreateSuperpartner.referente || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Referente" />
                </div>
                <div className='col-sm-12 col-md-6 my-2'>
                    <span className='small text-muted d-block mb-1'><b>Email</b></span>
                    <input name="email" value={formCreateSuperpartner.email || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Email" />
                </div>
            </div>
            <div className='row'>
                <div className='col-12 my-2'>
                    <span className='small text-muted d-block mb-1'><b>Note</b></span>
                    <textarea name="note" value={formCreateSuperpartner.note || ''} onChange={handleFormChange} className="form-control" rows={3} type="text" placeholder="Note" />
                </div>
            </div>
        </div>
    );
}

export default CreateSuperpartnerForm;